import React, { useCallback } from 'react'
import styled, { css } from 'styled-components/macro'
import { IconDiscordScalable, IconTelegramScalable, IconTwitterScalable, IconXterioLogoScalable } from 'xterio-icons'

const FooterFrame = styled.div`
  padding: 54.5px 60px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 54.5px 20px;
  `};
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    padding: 20px;
  `};
`
const FooterRow = styled.div<{ gap?: string }>`
  display: flex;
  flex-direction: row;
  items-content: center;
  justify-content: space-between;
  gap: ${({ gap }) => gap || '24px'};
  ${({ theme, gap }) => theme.mediaWidth.upToExtraSmall`
    gap: ${gap || '16px'}
  `};
`
const FooterRowAuto = styled(FooterRow)`
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
  `};
`

const Divider = styled.div`
  margin: 23px 0px;
  height: 1px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.1);
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    margin: 16px 0;
  `};
`
const IconLogo = styled(IconXterioLogoScalable)`
  width: 160px;
  height: 33px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 97px;
    height: 20px;
  `};
`
const createIconComp = (comp: any) => styled(comp)`
  width: 48px;
  height: 48px;
  cursor: pointer;
  &:hover {
    opacity: 0.5;
  }
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 24px;
    height: 24px;
  `};
`
const DiscordIcon = createIconComp(IconDiscordScalable)
const TwitterIcon = createIconComp(IconTwitterScalable)
const TelegramIcon = createIconComp(IconTelegramScalable)

const FooterText = styled.span<{ $color?: string; $size?: string; onClick?: () => void }>`
  font-size: ${({ $size }) => $size || '12px'};
  color: ${({ theme, $color }) => $color || theme.text40};
  line-height: 12px;
  ${({ onClick }) =>
    onClick
      ? css`
          cursor: pointer;
          &:hover {
            opacity: 0.5;
          }
        `
      : css``};
`
export default function Footer() {
  const onOpen = useCallback((url: string) => {
    window.open(url, '_blank')
  }, [])
  return (
    <FooterFrame>
      <FooterRow>
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <IconLogo color="rgba(255,255,255, 0.4)" />
        </span>
        <FooterRow>
          <DiscordIcon color="rgba(255,255,255, 0.4)" onClick={() => onOpen('https://discord.com/invite/xterio')} />
          <TwitterIcon color="rgba(255,255,255, 0.4)" onClick={() => onOpen('https://x.com/xteriogames')} />
          <TelegramIcon color="rgba(255,255,255, 0.4)" onClick={() => onOpen('https://t.me/XterioOfficial/41')} />
        </FooterRow>
      </FooterRow>
      <Divider />
      <FooterRowAuto>
        <FooterText>
          © Copyright 2025 Xterio Labs Limited. Xterio is the registered trademark of Xterio Foundation. All rights
          reserved.
        </FooterText>
        <FooterRow gap="40px">
          <FooterText onClick={() => onOpen('https://www.xter.io/legal/xterswap-terms-of-service')}>
            XTERSWAP TERMS OF SERVICE
          </FooterText>
          <FooterText onClick={() => onOpen('https://www.xter.io/legal/privacy-policy')}>PRIVACY POLICY</FooterText>
        </FooterRow>
      </FooterRowAuto>
    </FooterFrame>
  )
}
